import { Box, Button, Text } from "@chakra-ui/react"

import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/components/ui/dialog"

interface BulkUploadErrorModalProps {
  isOpen: boolean
  onClose: () => void
  errors: Array<{ row: number; error: string }>
}

export function BulkUploadErrorModal({
  isOpen,
  onClose,
  errors,
}: BulkUploadErrorModalProps) {
  const handleCopyAll = () => {
    const text = errors.map((e) => `Row ${e.row}: ${e.error}`).join("\n")
    navigator.clipboard.writeText(text)
  }

  return (
    <DialogRoot
      size="lg"
      placement="center"
      open={isOpen}
      onOpenChange={({ open }) => !open && onClose()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Upload Errors ({errors.length} errors)</DialogTitle>
        </DialogHeader>
        <DialogCloseTrigger />
        <DialogBody>
          <Box maxH="60vh" overflowY="auto">
            {errors.map((e, i) => (
              <Text key={i} fontFamily="mono" fontSize="sm" py={1}>
                Row {e.row}: {e.error}
              </Text>
            ))}
          </Box>
        </DialogBody>
        <DialogFooter gap={2}>
          <Button variant="subtle" colorPalette="gray" onClick={handleCopyAll}>
            Copy All
          </Button>
          <Button variant="solid" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}
